import {
    ActionStatuses,
    MarginTypes,
    LiquidityNeedsOptions,
    TimeHorizonOptions,
    InvestmentExperienceOptions,
    InvestmentObjectivesOptions,
    RiskToleranceOptions,
    AnnualIncomeOptions,
} from '@shared/api';

const fieldEnumMapping = {
    Status: ActionStatuses,
    'Margin Type': MarginTypes,
    'Liquidity Needs': LiquidityNeedsOptions,
    'Time Horizon': TimeHorizonOptions,
    'Investment Experience': InvestmentExperienceOptions,
    'Investment Objectives': InvestmentObjectivesOptions,
    'Risk Tolerance': RiskToleranceOptions,
    'Annual Income': AnnualIncomeOptions,
};

export const getSelectValue = (fieldName: string, value: string) => {
    if (value === 'true') return true;
    if (value === 'false') return false;

    const enumObject = fieldEnumMapping[fieldName as keyof typeof fieldEnumMapping];
    if (enumObject && value in enumObject) {
        return enumObject[value as keyof typeof enumObject] || '';
    }

    return value;
};
